export default {
  heading: 'Roboto, serif',
  subheading: 'Roboto',
  body: 'Roboto, sans-serif',
  body2: 'Roboto, sans-serif',
  monospace: 'Roboto, monospace',
  display: 'Roboto Garamond, cursive',
  googleFonts: ['Roboto:100,200,300,400,500,600,700,800,900']
  // customFamilies: ['Amelie', 'Corinthian Light', 'Futura'],
  // customUrls: [
  //   'https://www.gonation.biz/fonts/amelie/amelie.css',
  //   'https://www.gonation.biz/fonts/corinthian-light/corinthian-light.css',
  //   'https://www.gonation.biz/fonts/futura/futura.css'
  // ]
}
